module.exports = __webpack_public_path__ + "img/0916_nut.35e2f699.jpg";